import curriculoPDF from '../../../assets/curriculo_victor .pdf';

export const useHero = () => {
  return {
    title: 'Olá, eu sou Victor Neil',
    subtitle:
      'Desenvolvedor Full Stack apaixonado por criar soluções inovadoras e experiências digitais incríveis',
    cvHref: curriculoPDF,
    cvDownloadName: 'curriculo_victor .pdf',
  };
};
